import React, { useState, useEffect } from "react";
import * as R from "ramda";

import CommentIcon from "@material-ui/icons/Comment";
import HistoryIcon from "@material-ui/icons/History";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemText from "@material-ui/core/ListItemText";
import { makeStyles } from "@material-ui/core/styles";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import { Link } from "react-router";
import { eventId as getEventId } from "redux/modules/event/selectors";

import UploadContentMenu from "./UploadContentMenu";
import MobileUploadContentMenu from "./MobileUploadContentMenu";
import Comments from "./Comments";
import FileIcon from "ui-kit/FileIcon";

import { noop } from "utils/General";

import css from "./styles.scss";
import { connect } from "react-redux";
import { Text2, Div } from "components/Base";

const decorate = connect(state => ({
  eventId: getEventId(state)
}));

const FileDetails = ({
  file,
  isFirst = false,
  setHistoryVisibility = noop,
  historyCount = 0,
  isHistoryVisible = false,
  isExpanded = null,
  enableComments,
  accentColor,
  viaPortal,
  eventId
}) => {
  const useStyles = makeStyles(() => ({
    buttonText: {
      textTransform: "capitalize",
      margin: 0,
      color: accentColor ? accentColor : undefined
    },
    buttonRoot: { maxWidth: 200, margin: 0 },
    buttonIcon: { margin: 0 },
    listRoot: {
      marginLeft: 24,
      marginRight: 24,
      marginBottom: 15
    },
    listPadding: { padding: 0 },
    listItemRoot: { padding: 0 },
    listItemTextMultiline: { margin: 0 },
    listItemTextRoot: { fontWeight: 600 },
    listItemAvatarRoot: { minWidth: 45 },
    startIcon: { marginRight: 4 }
  }));

  const ICON_COLOR = accentColor ? accentColor : "#1e62d8";

  const [isCommentsVisible, setCommentsVisibility] = useState(isHistoryVisible);
  const classes = useStyles();

  useEffect(() => {
    if (isExpanded) setCommentsVisibility(isExpanded);
  }, [isExpanded]);

  return (
    <List classes={{ root: classes.listRoot, padding: classes.listPadding }}>
      <ListItem classes={{ root: classes.listItemRoot }}>
        {!isFirst ? (
          <ListItemAvatar
            classes={{
              root: classes.listItemAvatarRoot
            }}
          >
            <FileIcon
              bra={1}
              size={25}
              mimetype={file.mimetype}
              colorIcon="#BDBDBD"
              customStyle={{ color: "disabled" }}
            />
          </ListItemAvatar>
        ) : null}
        <ListItemText
          classes={{
            multiline: classes.listItemTextMultiline,
            root: classes.listItemTextRoot
          }}
          primary={
            <span
              style={{
                fontWeight: 700,
                color: "black",
                fontSize: "14px",
                wordBreak: "break-word"
              }}
            >
              {!viaPortal ? (
                <Link
                  to={`/event-light/${eventId}/files/${file.id}?returnTo=${window.location.pathname}`}
                >
                  {file.title}
                </Link>
              ) : (
                file.title
              )}
            </span>
          }
          secondary={
            <div
              style={{
                display: "flex",
                gap: 4,
                marginTop: 8,
                flexWrap: "wrap"
              }}
            >
              {R.prop("is_subsession_content", file) && (
                <>
                  <Text2>Subsession: {R.prop("session_name", file)}</Text2>|
                </>
              )}
              <Text2 className={css.uploaded}>
                Uploaded: {file.created_at_formatted}
              </Text2>
              |
              <Text2>
                {file.is_latest_version
                  ? `Latest Version${
                      file.version !== 1 ? ` (v${file.version})` : ""
                    }`
                  : `v${file.version}`}
              </Text2>
            </div>
          }
        />
        <Div
          display="row.flex-start.center"
          style={{ gap: 16, flexDirection: !viaPortal ? "row-reverse" : "row" }}
        >
          {viaPortal ? (
            <MobileUploadContentMenu fileId={file.id} />
          ) : (
            <UploadContentMenu
              fileId={file.id}
              isFirst={isFirst}
              fileMimetype={file.mimetype}
              viaPortal={viaPortal}
            />
          )}
          <div className={css.fileType}>{file.type_formatted}</div>
        </Div>
      </ListItem>

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flex: 1,
          marginBottom: 8,
          marginTop: 8
        }}
      >
        {isFirst && enableComments && file.comments ? (
          <Button
            size="small"
            color="primary"
            classes={{
              root: classes.buttonRoot,
              text: classes.buttonText,
              startIcon: classes.startIcon
            }}
            style={!isFirst ? { marginLeft: 40 } : {}}
            startIcon={<CommentIcon style={{ color: ICON_COLOR }} />}
            onClick={() => setCommentsVisibility(prevState => !prevState)}
          >
            {isCommentsVisible ? "Hide" : ""} Comments (
            {file.comments.length || 0})
          </Button>
        ) : null}

        {file.versions && file.versions.length ? (
          <Button
            size="small"
            color="primary"
            classes={{
              root: classes.buttonRoot,
              text: classes.buttonText,
              startIcon: classes.startIcon
            }}
            startIcon={<HistoryIcon style={{ color: ICON_COLOR }} />}
            onClick={() => setHistoryVisibility(prevState => !prevState)}
          >
            {isHistoryVisible ? "Hide" : ""} History ({historyCount})
          </Button>
        ) : null}
      </div>
      {enableComments && isCommentsVisible ? (
        <Comments
          comments={file.comments}
          isFirst={isFirst}
          idFileVersion={file.id}
          accentColor={accentColor}
          viaPortal={viaPortal}
        />
      ) : null}

      <Divider />
    </List>
  );
};

export default decorate(FileDetails);
